import Text from '@components/Text';
import colors from '@constants/colors';
import ToastFail from '@icons/toast/ToastFail';
import ToastInfo from '@icons/toast/ToastInfo';
import ToastSuccess from '@icons/toast/ToastSuccess';
import { toastMessageAtom, toastShowAtom, toastStatusAtom } from '@states/uiAtoms';
import { useAtom, useAtomValue } from 'jotai';

import styles from './styles.module.scss';

function Toast() {
  const [isShow, setIsShow] = useAtom(toastShowAtom);
  const message = useAtomValue(toastMessageAtom);
  const status = useAtomValue(toastStatusAtom);
  const Icon = (() => {
    switch (status) {
      case 'SUCCESS': return ToastSuccess;
      case 'ERROR': return ToastFail;
      default: return ToastInfo;
    }
  })();
  return (
        <div className={styles.wrapper}>
            <div className={`${styles.toast} ${(isShow) && styles.show}`}
                 onClick={(e) => {
                   e.preventDefault();
                   e.stopPropagation();
                   setIsShow(false);
                 }} >
                <Icon size={24} />
                <Text color={colors.gray6} fontWeight='bold' align='center'
                      className={styles.text} >
                    {message}
                </Text>
            </div>
        </div>
  );
}

export default Toast;
